import axios from "axios";
import { getAccessTokenApi } from "./auth";

const basePath = localStorage.getItem('SERVERCENTRAL');

/*##################MODULO PRINCIPAL SEGUIMIENTO#################*/

export function getTiposDocumentacionSeguimiento( data ) {
    const url = `${basePath}/consultaCatalogoTipoDocumentacionSeguimiento`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        'Content-Type': 'application/json',
        Accept: "application/json",
      }
    });
}

export function consultaTablaSeguimiento( data ) {
    const url = `${basePath}/consultaTablaSeguimiento`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        'Content-Type': 'application/json',
        Accept: "application/json",
      }
    });
}

export function procesaCargaMasivaSeguimiento( data ) {
  const url = `${basePath}/procesaCargaMasivaSeguimiento`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    }
  });
}

//######################MODAL REGISTRO SEGUIMIENTO ########################

export function consultaEmpresasSeguimiento( data ) {
  const url = `${basePath}/consultaEmpresas`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      'Content-Type': 'application/json',
      Accept: "application/json",
    }
  });
}

export function saveProduccion( data ) {
  const url = `${basePath}/guardaProduccion`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      'Content-Type': 'application/json',
      Accept: "application/json",
    }
  });
}

//#########################CONSULTA SEGUIMIENTO#################

export function getEmpresasConsultaSeguimiento( data ) {
  const url = `${basePath}/obtieneListaEmpresasByArticulo`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      'Content-Type': 'application/json',
      Accept: "application/json",
    }
  });
}

export function getTablaConsultaSeguimiento( data ) {
  const url = `${basePath}/obtieneTablaSeguimientoProduccion`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      'Content-Type': 'application/json',
      Accept: "application/json",
    }
  });
}

export function updateSeguimientoProduccion( data ) {
  const url = `${basePath}/editaSeguimientoProduccion`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      'Content-Type': 'application/json',
      Accept: "application/json",
    }
  });
}

export function deleteSeguimientoProduccion( data ) {
  const url = `${basePath}/eliminaSeguimientoProduccion`;
  const jwt = getAccessTokenApi();
  return axios.post(url,  data ,{
    headers: { 
      "Authorization": jwt,
      'Content-Type': 'application/json',
      Accept: "application/json",
    }
  });
}